import { SingularMentionCitationModalProps } from './types';

export const SOURCES = {
  impression: 'singular_mention_citation_modal_impression',
  dismiss: 'singular_mention_citation_modal_dismiss',
  ctaClick: 'singular_mention_citation_modal_cta_click',
} as const;

export type ModalTrackingExtra = {
  combined_mention_id: number;
  modal_name: 'singular_mention_citation_modal';
  is_citation: boolean;
  surface: string;
  layout: string;
  ab_arm: string;
  mentioning_work_id?: number | null;
  has_excerpt: boolean;
  record_rows: string[];
};

export function trackingExtra(
  props: SingularMentionCitationModalProps,
  recordRows: string[],
  hasExcerpt: boolean,
): ModalTrackingExtra {
  return {
    combined_mention_id: props.combinedMentionId,
    modal_name: 'singular_mention_citation_modal',
    is_citation: props.isCitation,
    surface: props.surface,
    layout: props.layout,
    ab_arm: props.abArm,
    mentioning_work_id: props.mentioningWorkId,
    has_excerpt: hasExcerpt,
    record_rows: recordRows,
  };
}
